// Creator Partner API client. Uses the same token the rest of InstaPass uses.
import { ApiURL } from "../setting/GlobleVariable";

export const TOKEN_KEY = "instapass_user_token";
export const getToken = () => {
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
};
export const setToken = (t) => {
  try {
    localStorage.setItem(TOKEN_KEY, t);
  } catch {}
};

export async function api(path, { method = "GET", body, auth = true } = {}) {
  const headers = { "Content-Type": "application/json" };
  const token = auth ? getToken() : null;
  if (token) headers.token = token;
  const res = await fetch(`${ApiURL}/creator${path}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });
  let data = {};
  try {
    data = await res.json();
  } catch {}
  if (!res.ok || data.success === false) {
    const err = new Error(data.message || `Request failed (${res.status})`);
    err.status = res.status;
    err.code = data.code;
    throw err;
  }
  return data;
}

/** Download an authenticated file (CSV exports) as a blob. */
export async function downloadAuthed(path, filename) {
  const res = await fetch(`${ApiURL}/creator${path}`, { headers: { token: getToken() || "" } });
  if (!res.ok) throw new Error("Download failed");
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

export const qrUrl = (code, format = "png", download = false) =>
  `${ApiURL}/creator/qr/${encodeURIComponent(code)}.${format}${download ? "?download=1" : ""}`;

export async function login(email, password) {
  const res = await fetch(`${ApiURL}/user/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, password }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || !data.Token) throw new Error(data.message || "Sign-in failed");
  setToken(data.Token);
  return data;
}

export const usd = (cents) =>
  `$${((cents || 0) / 100).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const fmtDate = (d, opts = { month: "short", day: "numeric", year: "numeric" }) =>
  d ? new Date(d).toLocaleDateString("en-US", opts) : "";
